histories-taskable-updated
  span.event {this.locale().event}
  span.updated
    histories-updated.location_id(if="{opts.json.location_id != undefined}" tag-scope="{this.tagScope}" scope="location_id" locale="{locale()}" getter="{locationName}" label-style="background: {phaseColorCode()}")
    histories-updated.planned_num(if="{opts.json.planned_num != undefined}" tag-scope="{this.tagScope}" scope="planned_num" locale="{locale()}" getter="{straight}" label-style="background: {phaseColorCode()}")
  script(type="typescript").
    this.mixin('histories.base');
